module.exports = __webpack_public_path__ + "static/media/15.6eb16501.png";